import React, { PropsWithChildren } from 'react'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { INCLUSIONS_TITLE_BONUS } from 'constants/inclusions'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import LabeledSheet from 'LuxKit/LabeledSheet'
import styled from 'styled-components'
import { rem } from 'polished'

const ContentWrapper = styled.div`
  padding: ${rem(16)};
`

interface Props {
  duration?: number;
}

function BonusInclusionsLabeledContainer(props: PropsWithChildren<Props>) {
  const { duration, children } = props

  return <LabeledSheet
    kind="highlight"
    data-testid="bonus-inclusions-labeled-container"
    label={<>
      <CSSBreakpoint not="tablet">
        {!!duration && <PromotionLabel variant="premium" format="propercase">{INCLUSIONS_TITLE_BONUS} for {duration} night stays</PromotionLabel>}
        {!duration && <PromotionLabel variant="premium" format="propercase">{INCLUSIONS_TITLE_BONUS}</PromotionLabel>}
      </CSSBreakpoint>
      <CSSBreakpoint only="tablet">
        <PromotionLabel variant="premium" format="propercase">{INCLUSIONS_TITLE_BONUS}</PromotionLabel>
      </CSSBreakpoint>
    </>}
  >
    <ContentWrapper>
      {children}
    </ContentWrapper>
  </LabeledSheet>
}

export default BonusInclusionsLabeledContainer
